import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {getBuildings, getCustomers} from '../actions';
import {CustomersTab, Layout, PageHeader} from '../components';
import { getAllBuildings } from '../actions/buildingsActions';

const Customers = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onAddCustomer = () => {
    navigate('/customers/new');
  };

  useEffect(() => {
    dispatch(getCustomers());
    dispatch(getBuildings());
    dispatch(getAllBuildings());
  }, []);

  return (
    <Layout>
      <PageHeader onAdd={onAddCustomer} title="Customers" />
      <CustomersTab />
    </Layout>
  );
};

export default Customers;
